<template>
  <!-- Payout 付款页面 -->
  <amount-payout v-if="isPayout || businessType === 'payout'"></amount-payout>
  <!-- 非 Payout 付款页面 -->
  <amount-normal v-else></amount-normal>
</template>
<script>
import { mapGetters } from 'vuex';

import AmountNormal from '@/views/transfer/transfer/add/amount/normal.vue';
import AmountPayout from '@/views/transfer/transfer/add/amount/payout.vue';

export default {
  components: {
    AmountPayout,
    AmountNormal,
  },
  computed: {
    ...mapGetters([
      'app',
    ]),
    businessType() {
      return this.$route.query.businessType || '';
    },
  },
  data() {
    return {
      isPayout: false,
    };
  },
  created() {
    // 商户类型
    try {
      const userLogin = this.app.userLogin;
      if (userLogin && userLogin.businessType === '0') {
        this.isPayout = true;
      } else if (userLogin && userLogin.businessType === '2') {
        this.isPayout = false;
      }
    } catch (error) {
      //
    }
  },
};
</script>
<style lang="scss">
@import '@/styles/variables.scss';
.exchange-form {
  margin-top: -68px;
}
.contact-info-box {
  display: flex;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  height: 80px;
  border-radius: 2px;
  border: 2px solid #9CBAEC;
  margin-bottom: 20px;
  margin-top: 60px;
  box-sizing: border-box;
  padding-left: 18px;
  padding-right: 20px;
  .contact-info-title {
    font-size: 16px;
    font-weight: bold;
    color: $color-text-primary;
    line-height: 22px;
  }
  .contact-info-desc {
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    font-weight: normal;
    color: $color-text-primary;
    line-height: 32px;
  }
}
.form-relactive {
  .rate-wrapper {
    width: 100%;
    position: relative;
    height: 103px;
    overflow: hidden;
    .line {
      width: 3px;
      height: 103px;
      background: $color-default;
      display: inline-block;
      margin: 0 0 0 22px;
      padding: 0;
      border: 0;
    }
    .rate-content {
      position: absolute;
      left: 12px;
      top: 50%;
      transform: translateY(-50%);
      display: flex;
      align-items: center;
      .close-icon {
        display: inline-block;
        width: 23px;
        height: 23px;
        background: $color-default;
        border-radius: 50%;
        text-align: center;
        line-height: 23px;
        .el-icon-minus {
          line-height: 23px;
          font-weight: bold;
        }
      }
      .rate-text {
        display: flex;
        margin-left: 13px;
        align-items: center;
        .rate-amount {
          font-size: 14px;
          font-weight: bold;
          line-height: 23px;
        }
        .time {
          margin-left: 32px;
          font-size: 14px;
          font-weight: 400;
          line-height: 23px;
        }
      }
    }
  }
  .transfer-tips {
    font-size: 14px;
    font-weight: 400;
    color: $color-text-primary;
    line-height: 20px;
  }
  .payer-check-label {
    color: $color-text-primary;
    font-weight: 800;
  }
}

// .bottom-box {
//   display: flex;
//   flex-direction: column;
//   align-items: center;

//   .btn-previous {
//     cursor: pointer;
//     color: $color-text-default-button;
//     font-weight: 600;
//   }
// }
</style>
